import {
    React,Component,BootstrapTable, Type,
    paginationFactory,Button, ButtonToolbar, Card,
    Form, Col, Row, Container, axios, Typeahead, Banner, TimePicker,
    cellEditFactory ,moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Accordion
} 
from '../../../noser-hris-component';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
class TADReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo            :   [],
            isloading           :   false,
            isshow              :   false,
            alerttype           :   "",
            message             :   "",
            color               :   "",
            fade                :   true,

            clientId            :   "",
            fromDate            :   "",
            toDate              :   "",
            positionDDL         :    [],
            positionId          :   "",
            sourcingChannel     :   "",
            sourcingChannelDDL  :   [],
            tadReportData       :   [],
            profileId           :  '',
            jobSourceId         :  '',

            periodId            :   "",
            employeeId          :   "",
            clientDDL           :   [],
            periodDDL           :   [],
            employeeDDL         :   [],
            dtrReportGrid       :   [],
        }
    }

    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.GetClients();
    }
    GetClients = async() => {
        this.setState({isloading:true})
        const param = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
        };
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList",  param)
        .then(res => {
            const data = res.data;
            this.setState({clientDDL:data.clients});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetPositionsList();
    }
    GetPositionsList = async () => {
        const param = {
            "IpAddress": "0.0.0.0",
            "UserId"        :   this.state.userinfo.userId,
            "ClientId"      :   this.state.userinfo.clientId,
            "ProfileId"     :   this.state.userinfo.profileId,
            "DateApplied"   :   this.state.userinfo.dateApplied,
            "PositionId"    :   this.state.userinfo.positionId,
            "JobSourceId"   :   this.state.userinfo.jobSourceId,
        };
    
        await axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetPositions", param)
            .then(res => {
                const data = res.data;
                this.setState({
                    positionDDL: data.positions || [],
                    isloading: false
                });
            })
            .catch(error => {
                console.error("Error in GetPositionsList:", error);
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred while fetching positions: " + error.message,
                    fade: true
                });
            });
        this.GetJobOpenings();
    };
    GetJobOpenings = async () => {
        const param = {
            "IpAddress": "0.0.0.0",
            "UserId": this.state.userinfo.userId,
            "ClientId": this.state.userinfo.clientId,
            "ProfileId": this.state.userinfo.profileId,
            "DateApplied": this.state.userinfo.dateApplied,
            "PositionId": this.state.userinfo.positionId,
            "JobSourceId": this.state.userinfo.jobSourceId
        };
    
        await axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetJobOpenings", param)
            .then(res => {
                const data = res.data;
                this.setState({
                    sourcingChannelDDL: data.jobOpenings || [],
                    isloading: false
                });
            })
            .catch(error => {
                console.error("Error in GetJobOpenings:", error);
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred while fetching job openings: " + error.message,
                    fade: true
                });
            });
    };
    GetRecruitmentTADReports = async () => {
        const params = {
            IpAddress: "0.0.0.0",
            UserId: this.state.userinfo.userId,
            ClientId: this.state.userinfo.clientId || this.state.clientId || "",
            DateFrom: this.state.dateFrom ? moment(this.state.dateFrom).format("YYYY-MM-DD") : "",
            DateTo: this.state.dateTo ? moment(this.state.dateTo).format("YYYY-MM-DD") : "",
            PositionId: this.state.userinfo.positionId || this.state.positionId || "",
            JobSourceId: this.state.userinfo.jobSourceId || this.state.jobSourceId || ""
        };
        await axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Report/GetRecruitmentTADReports", params)
            .then(res => {
                const data = res.data;
    
                console.log("GetRecruitmentTADReports response:", data);
    
                if (data.status === "1" && Array.isArray(data.data)) {
                    this.setState({ tadReportData: data.data, isloading: false });
                } else {
                    this.setState({
                        isloading: false,
                        tadReportData: [],
                        alerttype: "Warning!",
                        isshow: true,
                        color: "warning",
                        message: data.message || "No data found.",
                        fade: true
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Recruitment TAD Reports:", error);
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred: " + error.message,
                    fade: true
                });
            });
    }
    handleChangedPosition = (selected) => {
        if (selected.length === 0) {
            this.setState({ positionId: "" });
            return;
        }
        this.setState({ positionId: selected[0].id });
    };
    handleChangedSourcingChannel = (selected) => {
        if (selected.length === 0) {
            this.setState({ jobSourceId: "" });
            return;
        }
        this.setState({ jobSourceId: selected[0].id });
    };
    handleChangedClient = (e) => {
        this.setState({isloading:false,alerttype:'',isshow:false,color:'',message:'',fade:true})
        if(e.length == 0) {
            this.state.clientId=""
            return
        } 
        this.state.clientId = e[0].id
    }
    handleSearchClick = async () => {
        const { clientId, profileId, dateFrom, dateTo, positionId, jobSourceId, userinfo } = this.state;

        console.log("Validation Check:");
        console.log("DateApplied:", this.state.dateApplied);
        console.log("PositionId:", this.state.positionId);
        console.log("JobSourceId:", this.state.jobSourceId);
    
        // if (!dateApplied || !positionId || !jobSourceId) {
        //     this.setState({
        //         isloading: false,
        //         alerttype: "Warning!",
        //         isshow: true,
        //         color: "warning",
        //         message: "Please fill in Date Applied, Position, and Channel before searching.",
        //         fade: true
        //     });
        //     return;
        // }
    
        this.setState({isloading: true,alerttype: '',isshow: false,color: '',message: '',fade: true});
    
        const params = {
            IpAddress: "0.0.0.0",
            UserId: userinfo.userId,
            ClientId: clientId || "",
            // ProfileId: profileId || "",
            DateFrom: moment(dateFrom).format("YYYY-MM-DD"),
            DateTo: moment(dateTo).format("YYYY-MM-DD"),
            PositionId: positionId, 
            JobSourceId: jobSourceId
        };
        await axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Report/GetRecruitmentTADReports", params)
            .then(res => {
                const data = res.data;
                console.log(data)
                this.setState({
                    tadReportData: data.applications,
                    isloading: false
                });
            })
            .catch(error => {
                console.error("Error in GetRecruitmentTADReports:", error);
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred while fetching recruitment reports: " + error.message,
                    fade: true
                });
            });
    };

    handleDateAppliedChange = name => date => {
        this.setState({ [name]: date });
    };

    render() {
        const cols = [
            {
                dataField: 'client',
                text: 'CLIENT',
                headerStyle: () => ({ width:'35%',textAlign: 'center', fontSize: '10px', whiteSpace:'nowrap' }),
                style: { textAlign: 'left', fontSize: '10px',whiteSpace:'nowrap' }
            },
            {
                dataField: 'applicantName',
                text: 'NAME',
                headerStyle: () => ({ width:'25%',textAlign: 'center', fontSize: '10px', whiteSpace:'nowrap' }),
                style: { textAlign: 'left', fontSize: '10px',whiteSpace:'nowrap' }
            },
            {
                dataField: 'dateApplied',
                text: 'DATE APPLIED',
                headerStyle: () => ({ width:'10%',textAlign: 'center', fontSize: '10px', whiteSpace:'nowrap' }),
                style: { textAlign: 'center', fontSize: '10px',whiteSpace:'nowrap' }
            },
            {
                dataField: 'position',
                text: 'POSITION',
                headerStyle: () => ({ width:'20%',textAlign: 'center', fontSize: '10px',whiteSpace:'nowrap' }),
                style: { textAlign: 'left', fontSize: '10px',whiteSpace:'nowrap' }
            },
            {
                dataField: 'channel',
                text: 'CHANNEL',
                headerStyle: () => ({ width:'10%',textAlign: 'center', fontSize: '10px', whiteSpace:'nowrap' }),
                style: { textAlign: 'left', fontSize: '10px',whiteSpace:'nowrap' }
            }
        ]
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            hideSelectAll: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        const { ExportCSVButton } = CSVExport;
        return(
            <div>
                <Banner />
                <Container className="themed-container" fluid={true}>
                    <Card className="mt-5">
                        <Card.Header>TAD Report</Card.Header>
                        <Card.Body>
                            <Form >
                                <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                    <div className={this.state.color}></div> 
                                    {this.state.message}
                                </Alert>
                                <Card>
                                    <Accordion defaultActiveKey="1">
                                        <div className="card-header-tab">
                                            <Accordion.Toggle as={Button} variant="link" eventKey="1" style={{color: "#FFFFFF"}}>
                                                SEARCH FILTER
                                            </Accordion.Toggle>
                                        </div>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                <Form.Row>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>CLIENT</Form.Label>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Typeahead
                                                            labelKey='name'
                                                            id="basic-example"
                                                            onChange={this.handleChangedClient}
                                                            options={this.state.clientDDL}
                                                        />
                                                    </Col >
                                                    <Col sm={2}></Col>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>CHANNEL</Form.Label>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Typeahead
                                                            labelKey="name"
                                                            id="sourcing-channel-typeahead"
                                                            onChange={this.handleChangedSourcingChannel}
                                                            options={this.state.sourcingChannelDDL}
                                                            placeholder="Select sourcing channel"
                                                        />
                                                    </Col >
                                                </Form.Row>
                                                <Form.Row className='mt-3'>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>POSITION</Form.Label>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Typeahead
                                                            labelKey="name" 
                                                            id="position-typeahead"
                                                            onChange={this.handleChangedPosition}
                                                            options={this.state.positionDDL}
                                                            placeholder="Select position"
                                                        />
                                                    </Col >
                                                    <Col sm={2}></Col>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>DATE APPLIED</Form.Label>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <DatePicker
                                                            name="fromDate"
                                                            selected={this.state.fromDate}
                                                            onChange={this.handleDateAppliedChange("fromDate")}
                                                            dateFormat="MM/dd/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select date"
                                                        />
                                                    </Col >
                                                    <Col sm={2}>
                                                        <DatePicker
                                                            name="toDate"
                                                            selected={this.state.toDate}
                                                            onChange={this.handleDateAppliedChange("toDate")}
                                                            dateFormat="MM/dd/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select date"
                                                        />
                                                    </Col >
                                                </Form.Row>
                                                <ButtonToolbar sm={12} className="mt-4">
                                                    <Button variant="success" className="ml-auto noser-button" onClick = { this.handleSearchClick }>
                                                        SEARCH
                                                    </Button>
                                                </ButtonToolbar>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Accordion>
                                </Card>
                                <Card.Header className="mt-3"></Card.Header>
                                <ToolkitProvider
                                    keyField="id"   
                                    data={ this.state.tadReportData }
                                    columns={ cols }
                                    exportCSV={ {
                                        fileName: "Recruitment - TAD Reports.csv",
                                    } }
                                    >
                                    {
                                        props => (
                                        <div className="mt-3">
                                            <div>
                                            <BootstrapTable
                                                keyField = "id"
                                                data = { this.state.tadReportData }
                                                columns = { cols }
                                                selectRow = { selectRow }
                                                striped
                                                hover
                                                condensed
                                                loading={true}
                                                rowClasses="noser-table-row-class no-checkbox"
                                                pagination={ paginationFactory({sizePerPageRenderer})}
                                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                            />
                                            </div>
                                            <ButtonToolbar>
                                                <ExportCSVButton className="btn btn-info ml-auto" { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                                            </ButtonToolbar>
                                        </div>
                                        )
                                    }
                                </ToolkitProvider>
                            </Form>
                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
            </div> 
            
        )
    }
}

export default TADReport;